import {
  getRepositories as getRepositoriesApi,
  createRepositories as createRepositoriesApi,
  updateRepository as updateRepositoryApi,
  deleteRepository as deleteRepositoryApi,
  BACKFILL_TYPE
} from 'common/services/repositories.service';
import {
  getRepositoriesSucceed,
  createRepositoriesSucceed,
  getRepositoriesFailure,
  updateRepositorySucceed,
  deleteRepositorySucceed
} from '../actions';

export const getRepositories =
  (params = {}) =>
  async dispatch => {
    try {
      const repositories = await getRepositoriesApi(params);
      dispatch(getRepositoriesSucceed(repositories));
      return repositories;
    } catch ({ response = {} }) {
      dispatch(getRepositoriesFailure(response.status));
      return [];
    }
  };

export const createRepositories =
  (payload, backfillType = BACKFILL_TYPE.REPOSITORY, isV2) =>
  async dispatch => {
    try {
      if (isV2) {
        const message = await createRepositoriesApi(
          payload,
          backfillType,
          isV2
        );
        return message;
      } else {
        const repositories = await createRepositoriesApi(payload, backfillType);
        dispatch(createRepositoriesSucceed(repositories));
        return repositories;
      }
    } catch (e) {}
  };

export const updateRepository =
  (id, payload, backfill_metadata = {}) =>
  async dispatch => {
    try {
      const repository = await updateRepositoryApi(id, payload);
      const updatedRepository = {
        ...repository[0],
        backfill_metadata: {
          ...backfill_metadata,
          ...(payload.state === 'active' ? { state: 'initiated' } : {})
        }
      };
      dispatch(updateRepositorySucceed(updatedRepository));
      return updatedRepository;
    } catch (e) {
      return Promise.reject(e);
    }
  };

export const deleteRepository = id => async dispatch => {
  try {
    await deleteRepositoryApi(id);
    dispatch(deleteRepositorySucceed({ id }));
    return id;
  } catch (e) {}
};
